import React, { useEffect, useState } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/src/all";

const ScrollPrototype = () => {
    const [height, setHeight] = useState(window.innerHeight);

    // TODO
    // If the parent div has been scaled by a factor of 1.5,
    // then you need to scale the children by a factor of 1/1.5 = 0.(6)
    // to keep their size constant.
    useEffect(() => {
        gsap.to(".animate", {
            scale: height / 400,
            scrollTrigger: {
                trigger: ".animate",
                start: "top 85%",
                end: "bottom 100%",
                scrub: 3,
                markers: true,
            },
        });
    }, []);

    //TODO: Fix horizonal scrolling overflow
    return (
        <div data-name="ScrollPrototype" className="overflow-x-hidden">
            <div className=" animate origin-bottom overflow-x-hidden bg-red-200 h-[400px] w-full z-[1] absolute">
                <div className="text-center">Prompt Area</div>
            </div>
        </div>
    );
};

export default ScrollPrototype;
